import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import { SGSFormLayout } from 'components';
import { useArretTravailFormContext } from 'features/arretTravail/contexts/ArretTravailFormProvider';
import useValidationEffects from 'features/arretTravail/hooks/useValidationEffects';
import { getScenarioAtByCodes } from 'features/arretTravail/models/scenarii';
import React from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import RightsS3201 from './Sections/RightsS3201';
import RightsS3201Cotisation from './Sections/RightsS3201Cotisation';
import RightsS3201CotisAmount from './Sections/RightsS3201cotisAmount';
import RightsS3202Section from './Sections/RightsS3202';
import Accident from './Sections/accident';
import FirstConstationDate from './Sections/firstConstatationDate';
import Hospitalisation from './Sections/hospitalisation';
import ParentalLeaveStartDate from './Sections/parentalLeaveStartDate';
import Reprise from './Sections/reprise';
import SituationAtStopDate from './Sections/situationAtStopDate';
import WorkStoppageDetails from './Sections/workStoppageDetails';
import { useWorkStoppageSchema } from './schema';

type Props = {
    store: any;
    onSubmit: SubmitHandler<DeclarationTypeSchema>;
    actions?: JSX.Element;
};

type DeclarationTypeSchema = {
    workStoppage: {
        infos: {
            start: Date;
            end: Date;
            lastDayWorked: Date;
            isHospitalized: string;
            hospitalizedDate: Date;
            parentalLeaveStartDate: Date;
            childDateOfBirth: Date;
            firstConstatationDate: Date;
            returnToWorkCod: string;
            returnToWorkDate: Date;
            accidentDate: Date;
            hasOtherVictims: string;
            situationAtStopDateCod: string;
        };
        rights: {
            workedHours: string;
            period: string;
            start: string;
            end: string;
            contribution: string;
        };
        cotisation: {
            p12m: string;
            p6m: string;
        };
        hours: {
            cases800: string;
            cases200: string;
        };
    };
};

const FormWorkStoppage: React.FC<Props> = ({ onSubmit, store, actions }) => {
    const { activeStep, setStepFailed } = useArretTravailFormContext();
    const scenario = getScenarioAtByCodes(store);

    const validationSchema: Yup.SchemaOf<DeclarationTypeSchema> = Yup.object().shape({
        workStoppage: useWorkStoppageSchema({ store, scenario }),
    });

    const methods = useForm<DeclarationTypeSchema>({
        resolver: yupResolver(validationSchema),
        defaultValues: store,
    });

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = methods;

    useValidationEffects({ errors, activeStep, setStepFailed, control });

    console.log(errors);

    return (
        <FormProvider {...methods}>
            <SGSFormLayout onSubmit={handleSubmit(onSubmit)} actions={actions}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} md={6}>
                        <WorkStoppageDetails />
                        <Hospitalisation store={store} />
                        <ParentalLeaveStartDate store={store} />
                        <Reprise scenario={scenario} store={store} />
                        <Accident store={store} />
                        <SituationAtStopDate store={store} />
                        <RightsS3201 store={store} scenario={scenario} />
                        <RightsS3201Cotisation store={store} />
                        <RightsS3201CotisAmount store={store} />
                        <FirstConstationDate store={store} />
                        <RightsS3202Section store={store} />
                    </Grid>
                </Grid>
            </SGSFormLayout>
        </FormProvider>
    );
};

export default FormWorkStoppage;
